import OpportunityDetailsPage from '@totem/components/services/optimize/opportunityDetails/OpportunityDetailsPage';
import OptimizePage from '@totem/components/services/optimize/v1/optimizePage';
import BuildingDashboardPage from '@totem/components/services/optimize/v2/dashboard/BuildingDashboardPage';
import PortfolioDashboardPage from '@totem/components/services/optimize/v2/dashboard/PortfolioDashboardPage';
import ProgramDashboardPage from '@totem/components/services/optimize/v2/dashboard/ProgramDashboardPage';
import OptimizePage2 from '@totem/components/services/optimize/v2/optimizePage2';
import OptimizePage3 from '@totem/components/services/optimize/v3/optimizePage3';
import AgingDashboardPage from '@totem/components/ticketing/agingDashboard/AgingDashboardPage';
import TicketAssignmentsPage from '@totem/components/ticketing/assignments/TicketAssignmentsPage';
import TicketCategorizationPage from '@totem/components/ticketing/categorizationManagement/TicketCategorizationPage';
import ClaimTicketPage from '@totem/components/ticketing/claim/ClaimTicketPage';
import TicketDetailsPage from '@totem/components/ticketing/details/ticketDetailsPage';
import TicketsPage from '@totem/components/ticketing/list/TicketsPage';
import MyTicketsPage from '@totem/components/ticketing/myTickets/myTicketsPage';
import OpsTeamHuddlePage from '@totem/components/ticketing/opsTeamHuddle/OpsTeamHuddlePage';
import ProjectsDashboardPage from '@totem/components/ticketing/projectsDashboard/ProjectsDashboardPage';
import QueueManagementDetailsPage from '@totem/components/ticketing/queueManagement/details/QueueManagementDetailsPage';
import QueueManagementListPage from '@totem/components/ticketing/queueManagement/list/QueueManagementListPage';
import QueueTotalsPage from '@totem/components/ticketing/queueTotals/QueueTotalsPage';
import TemplateManagementDetailsPage from '@totem/components/ticketing/templateManagement/details/TemplateManagementDetailsPage';
import TemplateManagementListPage from '@totem/components/ticketing/templateManagement/list/TemplateManagementListPage';
import TicketDashboardPage from '@totem/components/ticketing/ticketDashboard/TicketDashboardPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const ticketingRoutes: Route[] = [
  {
    path: 'ticketing',
    pageTitle: 'Tickets',
    component: TicketsPage,
    exact: true,
    breadcrumbs: [{ label: 'Tickets' }],
    render: (userProfile: UserProfile) =>
      permissions.ticketingViewer.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'ticket/:id',
    pageTitle: 'Tickets',
    component: TicketDetailsPage,
    exact: true,
    breadcrumbs: [{ label: 'Ticket' }],
  },
  {
    path: 'ticket/:id/claim',
    pageTitle: 'Claim Ticket',
    component: ClaimTicketPage,
    exact: true,
    breadcrumbs: [{ label: 'Ticket' }, { label: 'Claim' }],
    render: (userProfile: UserProfile) =>
      permissions.ticketingInternal.hasPermissions(userProfile),
  },
  {
    path: 'optimize/ticket/:id',
    pageTitle: 'Tickets',
    component: TicketDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Optimize', link: '/optimize2' },
      { label: 'Ticket' },
    ],
  },
  {
    path: 'optimize/opportunity/:id',
    pageTitle: 'Opportunity',
    component: OpportunityDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Optimize', link: '/optimize2' },
      { label: 'Opportunity' },
    ],
  },
  {
    path: 'myTickets',
    pageTitle: 'My Tickets',
    component: MyTicketsPage,
    exact: true,
    breadcrumbs: [{ label: 'My Tickets' }],
  },
  {
    path: 'ticketingQueues',
    pageTitle: 'Ticket Queues',
    component: QueueTotalsPage,
    exact: true,
    breadcrumbs: [{ label: 'Ticket Queues' }],
    render: (userProfile: UserProfile) =>
      permissions.ticketingInternal.hasPermissions(userProfile),
  },
  {
    path: 'ticketingTemplates',
    pageTitle: 'Task Templates',
    component: TemplateManagementListPage,
    exact: true,
    breadcrumbs: [{ label: 'Task Templates' }],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile) &&
      permissions.ticketingAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'ticketingTemplate/:templateId',
    pageTitle: 'Task Template Details',
    component: TemplateManagementDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Task Templates', link: '/ticketingTemplates' },
      { label: 'Task Template' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile) &&
      permissions.ticketingAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'ticketAssignments',
    pageTitle: 'Ticket Assignments',
    component: TicketAssignmentsPage,
    exact: true,
    breadcrumbs: [{ label: 'Ticket Assignments' }],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile) &&
      permissions.ticketingAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'ticketingCategorization',
    pageTitle: 'Ticket Categorization',
    component: TicketCategorizationPage,
    exact: true,
    breadcrumbs: [{ label: 'Ticket Categorization' }],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile) &&
      permissions.ticketingAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'ticketingQueueManagement',
    pageTitle: 'Queue Administration',
    component: QueueManagementListPage,
    exact: true,
    breadcrumbs: [{ label: 'Queue Administration' }],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile) &&
      permissions.ticketingAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'ticketingQueueManagement/:queueId',
    pageTitle: 'Queue Details',
    component: QueueManagementDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Queue Administration', link: '/ticketingQueueManagement' },
      { label: 'Queue' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile) &&
      permissions.ticketingAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'ticketAging',
    pageTitle: 'Ticket Aging',
    // Previous version: @totem/components/ticketing/agingReport/AgingReportPage
    component: AgingDashboardPage,
    exact: true,
    breadcrumbs: [{ label: 'Ticket Aging' }],
    render: (userProfile: UserProfile) =>
      permissions.ticketingInternal.hasPermissions(userProfile),
  },
  {
    path: 'opsTeamHuddle',
    pageTitle: 'Ops Team Huddle',
    component: OpsTeamHuddlePage,
    exact: true,
    breadcrumbs: [{ label: 'Ops Team Huddle' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'ticketDashboard',
    pageTitle: 'Ticket Dashboard',
    component: TicketDashboardPage,
    exact: true,
    breadcrumbs: [{ label: 'Ticket Dashboard' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'projectsDashboard',
    pageTitle: 'Project Health',
    component: ProjectsDashboardPage,
    exact: true,
    breadcrumbs: [{ label: 'Project Health' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'optimize',
    pageTitle: 'Optimize',
    component: OptimizePage3,
    exact: true,
    breadcrumbs: [{ label: 'Optimize' }],
    render: (userProfile: UserProfile) =>
      permissions.optimize.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'optimize2',
    pageTitle: 'Optimize',
    component: OptimizePage3,
    exact: true,
    breadcrumbs: [{ label: 'Optimize' }],
    render: (userProfile: UserProfile) =>
      permissions.optimize.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'optimize3',
    pageTitle: 'Optimize',
    component: OptimizePage3,
    exact: true,
    breadcrumbs: [{ label: 'Optimize' }],
    render: (userProfile: UserProfile) =>
      permissions.optimize.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'optimize/dashboard',
    pageTitle: 'Optimize Dashboard',
    component: PortfolioDashboardPage,
    exact: true,
    breadcrumbs: [
      { label: 'Optimize', link: '/optimize2' },
      { label: 'Programs' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.optimize.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'optimize/buildings/:buildingId/dashboard',
    pageTitle: 'Optimize Building Dashboard',
    component: BuildingDashboardPage,
    exact: true,
    breadcrumbs: [
      { label: 'Optimize', link: '/optimize2' },
      { label: 'Programs', link: '/optimize/dashboard' },
      { label: 'Building' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.optimize.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'optimize/buildings/:buildingId/programs/:programId/dashboard',
    pageTitle: 'Optimize Program Dashboard',
    component: ProgramDashboardPage,
    exact: true,
    breadcrumbs: [
      { label: 'Optimize', link: '/optimize2' },
      { label: 'Programs', link: '/optimize/dashboard' },
      { label: 'Program' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.optimize.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
